export default __webpack_public_path__ + "static/media/3.3bc03658.png";